
import * as React from 'react';
import {useEffect, useState} from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import {
  Divider,
  IconButton,
  Select,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Grid,
  FormHelperText
} from '@mui/material';
import { printVariable } from '@util/helper';
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import moment from 'moment';
import useDelegate from "@hooks/useDelegate";
import {styled} from "@mui/material/styles";
import useAlert from "@hooks/useAlert";
import ConfirmDialog from "@components/ConfirmDialog";
import { useExpanded } from 'react-table';
import Linker from '@components/Linker'
import {useParams} from "react-router-dom";
const TeacherMessagePartUser = ({record, dialogHandler}) => {
	const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
	const { alert, renderAlert } = useAlert()
  const [dataList, set_dataList] = useState([])

  const {more} = useParams()
  const fields = [
    {field: 'id', placeholder: 'ID',    type:'text', value: -1, visible: more && (more === 'more'), canSrch: false, selList:[]},
    {field: 'name', placeholder: '수신인',    type:'text', value: '', visible: true, canSrch: false, selList:[]},
    {field: 'phone', placeholder: '전화번호',    type:'text', value: '', visible: true, canSrch: false, selList:[]},
    {field: 'readYn', placeholder: '읽음여부',    type:'text', value: '', visible: true, canSrch: false, selList:[]},
  ]

  const fetchRecvs = async () => {
    const url = `/topic/message/${record.id}`
    openIndicator()
    const resp = await WebService.get(url) 
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const report = JSON.parse(repMessage.report)
    return report
  }

  const onLoad = async() => {
    const report = await fetchRecvs()
    report.forEach(r => {
      r.readYn = r.topic.readYn
    })
    console.log('report=>', report)
    set_dataList(report)
  }

  useEffect(() => {
    onLoad()
  },[])

  return (
    <div style={{whiteSpace:'pre-line'}}>
      <div style={{minHeight:500, maxHeight:500, overflow:'auto'}}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container>
              {
                fields.map((col, idx) => (
                  col.visible ? (
                    <Grid item xs key={idx}>
                      <Typography>{col.placeholder}</Typography>
                    </Grid>
                  ) : null
                ))
              }
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
          {
            dataList.map((row, ridx) => (
              <Grid container key={ridx}>
                {
                  fields.map((col, cidx) => (
                    col.visible ? (
                      <Grid item xs key={cidx}>
                        <Typography variant='body2'>{row[col.field]}</Typography>
                      </Grid>
                    ) : null
                  ))
                }
              </Grid>
            ))
          }
          </Grid>
        </Grid>
      </div>
      <div >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Divider/>
          </Grid>
          <Grid item xs={12} style={{display:'flex', justifyContent:'center'}}>
            <Button
              onClick={() => dialogHandler[1](false)}
            >
              닫기
            </Button>
          </Grid>
        </Grid>

      </div>
      <div>
        {renderIndicator()}
        {renderAlert()}
      </div>
    </div>
  )
}

export default TeacherMessagePartUser
